import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Card, CardBody, Col, Label, Row } from "reactstrap"
import {
  AvFeedback,
  AvField,
  AvForm,
  AvGroup,
  AvInput,
} from "availity-reactstrap-validation"
import Select from "react-select"
import { useHistory } from "react-router-dom"

import { useDispatch, useSelector } from "react-redux"
import {
  createInspectionBooking,
  getBrands,
  getDistricts,
  getStates,
  updateInspectionBooking,
} from "store/actions"

function Form({ updateData }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const isTablet = window.innerWidth <= 768
  const { allDistricts, allState, brand, loadingCreate } = useSelector(
    state => ({
      allState: state?.Client?.states?.States,
      allDistricts: state?.Client?.districts?.districts,
      brand: state.Brand.brands?.brands,
      loadingCreate: state.Inspection.loadingCreate,
    })
  )

  const [paymentType, setPaymentType] = useState({
    label: "Pay Later",
    value: "PAY_LATER",
  })
  const [paymentStatus, setPaymentStatus] = useState({
    label: "Unpaid",
    value: "UNPAID",
  })

  const [status, setStatus] = useState({ label: "New", value: "NEW" })
  const [state, setState] = useState("")
  const [stateId, setStateId] = useState("")
  const [stateSearch, setStateSearch] = useState("")

  const [district, setDistrict] = useState("")
  const [districtId, setDistrictId] = useState("")
  const [districtSearch, setDistrictSearch] = useState("")

  useEffect(() => {
    dispatch(getStates(stateSearch))
  }, [dispatch, stateSearch])

  useEffect(() => {
    setDistrictId(updateData?.user_details?.district?._id)
    setDistrict(updateData?.user_details?.district?.name)

    setState(updateData?.user_details?.state?.name)
    setStateId(updateData?.user_details?.state?._id)
  }, [updateData])

  const stateOptions = [
    {
      options: allState?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredStates = textEntered => {
    setStateSearch(textEntered)
  }

  function handleFinalValuesStates(event) {
    setState(event.label)
    setStateId(event.value)
  }

  useEffect(() => {
    if (stateId) {
      dispatch(getDistricts(stateId, districtSearch))
    }
  }, [dispatch, stateId, districtSearch])

  const districtOptions = [
    {
      options: allDistricts?.map((result, index) => ({
        key: index,
        label: result?.name,
        value: result._id,
      })),
    },
  ]

  const handleEnteredDistrict = textEntered => {
    setDistrictSearch(textEntered)
  }

  function handleFinalValuesDistrict(event) {
    setDistrict(event.label)
    setDistrictId(event.value)
  }

  const [brandValue, setBrandValue] = useState("Select Brand...")
  const [brandId, setBrandId] = useState()
  const [brandAmount, setBrandAmount] = useState()

  const [brandSearch, setBrandSearch] = useState("")

  const handleEnter = textEntered => {
    setBrandSearch(textEntered)
  }

  function handlerFinalValuesBrand(event) {
    if (event?.label === "Clear") {
      setBrandValue(event.value)
      setBrandAmount(null)
      setBrandId(null)
    } else {
      setBrandValue(event.label)
      setBrandId(event.value)
      setBrandAmount(event.amount)
    }
  }

  const brandOptions = [
    {
      label: "Clear",
      value: "select a brand",
    },
    {
      options: (brand?.length >= 1 ? brand : [])?.map((results, index) => ({
        key: index,
        label: results.name,
        value: results._id,
        amount:
          results?.inspection_charge?.offer_price != null
            ? results.inspection_charge.offer_price
            : results?.inspection_charge?.price,
      })),
    },
  ]

  useEffect(() => {
    setPaymentType(updateData?.payment_type)
    setBrandId(updateData?.vehicle_details?.brand?._id)
    setBrandAmount(
      updateData?.vehicle_details?.brand?.inspection_charge?.offer_price ||
        updateData?.vehicle_details?.brand?.inspection_charge?.price
    )
    setBrandValue(updateData?.vehicle_details?.brand?.name)
    setStateId(updateData?.user_details?.state?._id)
    setState(updateData?.user_details?.state?.name)
    setDistrictId(updateData?.user_details?.district?._id)
    setDistrict(updateData?.user_details?.district?.name)
    setPaymentStatus(
      updateData?.payment_status === "PAID"
        ? { label: "Paid", value: "PAID" }
        : { label: "Unpaid", value: "UNPAID" }
    )
  }, [updateData])

  useEffect(() => {
    dispatch(getBrands(1, "", 10, brandSearch))
  }, [brandSearch])

  const [sameAsPhone, setSameAsPhone] = useState(false)
  const [whatsappValue, setWhatsappValue] = useState(
    updateData?.user_details?.whatsapp || ""
  )
  const [phoneValue, setPhoneValue] = useState(
    updateData?.user_details?.phone || ""
  )
  useEffect(() => {
    const phone = updateData?.user_details?.phone || ""
    const whatsapp = updateData?.user_details?.whatsapp || ""
    setPhoneValue(phone)
    setWhatsappValue(whatsapp)
    setSameAsPhone(phone && whatsapp && phone === whatsapp)
  }, [updateData])

  useEffect(() => {
    if (sameAsPhone) {
      setWhatsappValue(phoneValue)
    }
  }, [sameAsPhone, phoneValue])

  useEffect(() => {
    setPhoneValue(updateData?.user_details?.phone || "")
  }, [updateData?.user_details?.phone])

  const handleValidSubmit = (e, v) => {
    const createData = {
      // ...v,
      user_details: {
        name: v?.name,
        phone: v?.phone,
        whatsapp: sameAsPhone ? v?.phone : v?.whatsapp,
        // country_code: countryCodeWithPlus,
        address: v?.address,
        pincode: v?.pincode,
        city: v?.city,
        state: stateId || null,
        district: districtId || null,
      },
      vehicle_details: {
        brand: brandId || null,
      },
      note: v?.note,

      ...(status?.value && { booking_status: status.value }),
      payment_type: paymentType?.value,
      payment_status: {
        is_paid: paymentStatus?.value === "PAID" ? true : false,
        paid_at: v?.paid_at,
      },
    }

    if (updateData?._id) {
      dispatch(updateInspectionBooking(createData, updateData?._id, ""))
    } else {
      dispatch(createInspectionBooking(createData, history))
    }
  }
  useEffect(() => {
    const paymentOptions = [
      { label: "Online", value: "ONLINE" },
      { label: "Pay Later", value: "PAY_LATER" },
    ]
    const matchedPayment = paymentOptions.find(
      option => option.value === updateData?.payment_type
    )

    // If no value in updateData, default to Pay Later
    setPaymentType(matchedPayment || { label: "Pay Later", value: "PAY_LATER" })
  }, [updateData])

  const statusOptions = [
    { label: "New", value: "NEW" },
    { label: "Pending", value: "PENDING" },
    { label: "Processing", value: "PROCESSING" },
    { label: "Completed", value: "COMPLETED" },
  ]

  useEffect(() => {
    if (updateData?._id && updateData?.booking_status) {
      const matched = statusOptions.find(
        s => s.value === updateData.booking_status
      )
      setStatus(matched || null)
    }
  }, [updateData])

  return (
    <div>
      <AvForm
        onValidSubmit={(e, v) => {
          handleValidSubmit(e, v)
        }}
      >
        <Row>
          <>
            <Col sm="12">
              <Card className={isTablet ? "w-100" : "w-100"}>
                <CardBody>
                  <Row className="pt-1 px-0">
                    <>
                      <Row className="bg-light px-1 py-2 mb-3 heading-document">
                        <Col>
                          <span>CUSTOMER DETAILS</span>
                        </Col>
                      </Row>
                      <Row>
                        <>
                          <Col className="mb-2  col-4">
                            <label>
                              User Name <span className="text-danger"> *</span>
                            </label>
                            <AvField
                              name="name"
                              type="text"
                              required
                              placeholder="Enter Name "
                              value={updateData?.user_details?.name}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Name is required",
                                },
                              }}
                            />
                          </Col>

                          <Col className="col-4">
                            <label>
                              Phone <span className="text-danger"> *</span>
                            </label>

                            <AvField
                              name="phone"
                              type="number"
                              placeholder="Enter Phone "
                              value={phoneValue}
                              onChange={e => {
                                const value = e.target.value
                                // Only allow digits and limit to 10 characters
                                if (/^\d{0,10}$/.test(value)) {
                                  setPhoneValue(value)
                                }
                              }}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Phone Number is required",
                                },
                                pattern: {
                                  value: "^[0-9]{10}$",
                                  errorMessage:
                                    "Phone Number must be 10 digits",
                                },
                              }}
                            />
                          </Col>

                          <Col className="col-4" style={{ marginTop: "2px" }}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginBottom: "5px",
                              }}
                            >
                              <label style={{ marginBottom: 0 }}>
                                WhatsApp
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="sameAsPhone"
                                  checked={sameAsPhone}
                                  onChange={e =>
                                    setSameAsPhone(e.target.checked)
                                  }
                                  style={{
                                    accentColor: "#00A76F",
                                    width: 12,
                                    height: 12,
                                    marginRight: 6,
                                  }}
                                />
                                <label
                                  htmlFor="sameAsPhone"
                                  style={{
                                    marginBottom: 0,
                                    cursor: "pointer",
                                    fontWeight: 500,
                                  }}
                                >
                                  Same as Phone
                                </label>
                              </div>
                            </div>
                            <AvField
                              name="whatsapp"
                              type="number"
                              placeholder="Enter Whatsapp Number "
                              value={whatsappValue}
                              disabled={sameAsPhone}
                              onChange={e => {
                                const value = e.target.value
                                // Only allow digits and limit to 10 characters
                                if (/^\d{0,10}$/.test(value)) {
                                  setWhatsappValue(value)
                                }
                              }}
                              validate={{
                                required: {
                                  value: false,
                                  errorMessage: "Phone Number is required",
                                },
                                pattern: {
                                  value: "^[0-9]{10}$",
                                  errorMessage:
                                    "Whatsapp Number must be 10 digits",
                                },
                              }}
                            />
                          </Col>
                          {/* {updateData?._id && (
                            <Col className="col-6 mb-2">
                              <label>Status</label>
                              <Select
                                value={status}
                                onChange={setStatus}
                                options={statusOptions}
                                classNamePrefix="select2-selection"
                                placeholder="Select Status"
                              />
                            </Col>
                          )} */}
                        </>
                      </Row>
                      <Row>
                        <Col xs={12} md={8}>
                          <Row md={12}>
                            <Col md={6}>
                              <label>State</label>
                              <Select
                                onInputChange={handleEnteredStates}
                                value={state}
                                placeholder={state}
                                onChange={handleFinalValuesStates}
                                options={stateOptions}
                                classNamePrefix="select2-selection"
                                isLoading={""}
                              />
                            </Col>
                            <Col md={6}>
                              <label>District</label>
                              <Select
                                onInputChange={handleEnteredDistrict}
                                value={district}
                                isDisabled={!stateId}
                                placeholder={district}
                                onChange={handleFinalValuesDistrict}
                                options={districtOptions}
                                classNamePrefix="select2-selection"
                                isLoading={""}
                              />
                            </Col>
                          </Row>
                          <Row md={12} style={{ marginTop: "12px" }}>
                            <Col md={6}>
                              <AvField
                                label="City"
                                name="city"
                                type="text"
                                placeholder="Enter your city"
                                value={updateData?.user_details?.city ?? ""}
                              />
                            </Col>
                            <Col md={6}>
                              <AvField
                                name="pincode"
                                type="number"
                                label="Pincode"
                                placeholder=" Pincode"
                                value={updateData?.user_details?.pincode ?? ""}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col xs={12} md={4}>
                          {" "}
                          <label>Address</label>
                          <AvField
                            name="address"
                            placeholder="Enter Address.."
                            type="textarea"
                            rows="5"
                            value={updateData?.user_details?.address ?? ""}
                          />
                        </Col>
                      </Row>

                      <Row className="bg-light px-1 py-2 my-3 heading-document">
                        <Col>
                          <span>PAYMENT DETAILS</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={8} lg={3}>
                          <AvGroup>
                            <Label for="brand">
                              Brand <span className="text-danger">*</span>
                            </Label>

                            <Select
                              onInputChange={handleEnter}
                              value={brandValue}
                              placeholder={brandValue}
                              onChange={handlerFinalValuesBrand}
                              options={brandOptions}
                              classNamePrefix="select2-selection"
                              isRequired={true}
                            />
                            <AvInput
                              name="brand"
                              value={brandValue || ""}
                              required
                              hidden
                            />
                            <AvFeedback>Brand is required</AvFeedback>
                          </AvGroup>
                        </Col>
                        {isTablet && (
                          <Col md={4}>
                            <AvField
                              name="amount"
                              type="number"
                              label="Amount"
                              disabled={true}
                              placeholder=" Amount"
                              value={brandAmount}
                            />
                          </Col>
                        )}
                        <Col md={12} lg={9}>
                          <Row>
                            {!isTablet && (
                              <Col md={3}>
                                <AvField
                                  name="amount"
                                  type="number"
                                  label="Amount"
                                  disabled={true}
                                  placeholder=" Amount"
                                  value={brandAmount}
                                />
                              </Col>
                            )}
                            <>
                              <Col md={4} lg={3} className=" ">
                                <AvGroup className="mt-3">
                                  <label>Payment Type </label>
                                  <div className="d-flex align-items-center gap-3">
                                    <Label className="d-flex align-items-center gap-1 mb-0">
                                      <input
                                        type="radio"
                                        name="payment_type"
                                        value="ONLINE"
                                        checked={
                                          paymentType?.value === "ONLINE"
                                        }
                                        onChange={() =>
                                          setPaymentType({
                                            label: "Online",
                                            value: "ONLINE",
                                          })
                                        }
                                        required
                                        style={{ accentColor: "#00A76F" }}
                                      />
                                      Online
                                    </Label>
                                    <Label className="d-flex align-items-center gap-1 mb-0">
                                      <input
                                        type="radio"
                                        name="payment_type"
                                        value="PAY_LATER"
                                        checked={
                                          paymentType?.value === "PAY_LATER"
                                        }
                                        onChange={() =>
                                          setPaymentType({
                                            label: "Pay Later",
                                            value: "PAY_LATER",
                                          })
                                        }
                                        required
                                        style={{ accentColor: "#00A76F" }}
                                      />
                                      Pay Later
                                    </Label>
                                  </div>
                                  <AvInput
                                    name="payment_type"
                                    value={paymentType?.value || ""}
                                    required
                                    hidden
                                  />
                                  <AvFeedback>
                                    Payment type is required
                                  </AvFeedback>
                                </AvGroup>
                              </Col>
                              <Col md={4} lg={3}>
                                <AvGroup className="mt-3">
                                  <label>Payment Status </label>
                                  <div className="d-flex align-items-center gap-3">
                                    <Label className="d-flex align-items-center gap-1 mb-0">
                                      <input
                                        type="radio"
                                        name="payment_status"
                                        value="PAID"
                                        checked={
                                          paymentStatus?.value === "PAID"
                                        }
                                        onChange={() =>
                                          setPaymentStatus({
                                            label: "Paid",
                                            value: "PAID",
                                          })
                                        }
                                        required
                                        style={{ accentColor: "#00A76F" }}
                                      />
                                      Paid
                                    </Label>
                                    <Label className="d-flex align-items-center gap-1 mb-0">
                                      <input
                                        type="radio"
                                        name="payment_status"
                                        value="UNPAID"
                                        checked={
                                          paymentStatus?.value === "UNPAID"
                                        }
                                        onChange={() =>
                                          setPaymentStatus({
                                            label: "Unpaid",
                                            value: "UNPAID",
                                          })
                                        }
                                        required
                                        style={{ accentColor: "#00A76F" }}
                                      />
                                      Unpaid
                                    </Label>
                                  </div>
                                  <AvInput
                                    name="payment_status"
                                    value={paymentStatus?.value || ""}
                                    required
                                    hidden
                                  />
                                  <AvFeedback>
                                    Payment status is required
                                  </AvFeedback>
                                </AvGroup>
                              </Col>
                              {paymentStatus?.value === "PAID" && (
                                <Col
                                  md={4}
                                  lg={3}
                                  style={{
                                    marginTop: isTablet ? "0.5rem" : ".5rem",
                                  }}
                                >
                                  <p style={{ marginBottom: isTablet ? 1 : 2 }}>
                                    Paid On{" "}
                                    <span className="text-danger">*</span>
                                  </p>
                                  <AvField
                                    name="paid_at"
                                    placeholder="Enter Paid On  Date.."
                                    type="date"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "Paid On is required",
                                      },
                                    }}
                                    value={
                                      new Date().toISOString().split("T")[0]
                                    }
                                  />
                                </Col>
                              )}
                            </>
                            {/* )} */}
                          </Row>
                        </Col>
                      </Row>
                      <Row className="bg-light px-1 py-2 my-3 heading-document">
                        <Col>
                          <span>BOOKING STATUS</span>
                        </Col>
                      </Row>
                      <Row>
                        {updateData?._id && (
                          <Col md={6}>
                            <AvGroup className="mt-3">
                              <label>Booking Status</label>
                              <div className="d-flex align-items-center gap-3">
                                {statusOptions.map(option => (
                                  <Label
                                    key={option.value}
                                    className="d-flex align-items-center gap-1 mb-0"
                                  >
                                    <input
                                      type="radio"
                                      name="booking_status"
                                      value={option.value}
                                      checked={status?.value === option.value}
                                      onChange={() => setStatus(option)}
                                      required
                                      style={{ accentColor: "#00A76F" }}
                                    />
                                    {option.label}
                                  </Label>
                                ))}
                              </div>
                              <AvInput
                                name="booking_status"
                                value={status?.value || ""}
                                required
                                hidden
                              />
                              <AvFeedback>
                                Booking status is required
                              </AvFeedback>
                            </AvGroup>
                          </Col>
                        )}
                        <Col md={6}>
                          {" "}
                          <label>Note</label>
                          <AvField
                            name="note"
                            placeholder="Enter note.."
                            type="textarea"
                            rows="1"
                            value={updateData?.note ?? ""}
                          />
                        </Col>
                      </Row>
                    </>
                  </Row>
                  <div
                    className="d-flex align-items-center text-center "
                    style={{ marginTop: "1px" }}
                  >
                    <hr className="flex-grow-1 solid-line" />
                  </div>
                  <Row className="align-items-center justify-content-center mt-1">
                    <Col
                      md={3}
                      lg={2}
                      className="px-1"
                      style={{
                        width: "fit-content",
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="w-100 d-flex align-items-center justify-content-end py-2 mb-0">
                        <Button
                          className="w-100 px-5 btn-rounded "
                          color="outline-warning"
                          onClick={() => history.goBack()}
                        >
                          {"close"}
                        </Button>
                      </div>
                    </Col>
                    <Col
                      md={3}
                      lg={2}
                      style={{
                        zIndex: 1000,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        justifyContent: "flex-start",
                      }}
                    >
                      <Button
                        className="px-5 btn-rounded "
                        color="warning"
                        type="submit"
                        style={{ width: "140px" }}
                        disabled={loadingCreate}
                      >
                        {loadingCreate ? (
                          <div
                            className="spinner-border text-light"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          />
                        ) : (
                          "Save"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </>
        </Row>
      </AvForm>
    </div>
  )
}

export default Form

Form.propTypes = {
  updateData: PropTypes.any,
}

// ..
